import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Container,
  Button,
  Paper,
  Avatar,
  Stack,
} from "@mui/material";
import LoginIcon from "../components/LoginIcon";
import { LoginIconType } from "../models/components/LoginIconModel";
import { signInWithGoogle, signOut } from "../firebaseSetup";
import useAuth from "../hooks/useAuth";
import Config from "../models/Config";
import PageHeader from "../components/PageHeader";
import { Navigate } from "react-router-dom";


function AdminPage() {
      const navigate = require('react-router-dom').useNavigate();

    // ...existing code...
    // ...existing code...
  const user = useAuth();
  // Show unauthorized message if user is signed in but not admin
  const isSignedIn = !!user && !!user.user;
  const isAdmin = !!user && user.isAdmin;
  const [signingIn, setSigningIn] = React.useState(false);
  const [signInError, setSignInError] = React.useState<string | null>(null);

      // Redirect to dashboard if user becomes admin after a failed login
      React.useEffect(() => {
        if (isSignedIn && isAdmin) {
          navigate('/admin/dashboard', { replace: true });
        }
      }, [isSignedIn, isAdmin, navigate]);
    // Clear error when user or admin status changes (successful login)
    React.useEffect(() => {
      setSignInError(null);
    }, [isSignedIn, isAdmin]);

  const handleSignIn = async () => {
    if (signingIn) return; // Prevent multiple popups
    setSignInError(null);
    setSigningIn(true);
    try {
      await signInWithGoogle();
    } catch (err: any) {
      if (err && err.code === 'auth/cancelled-popup-request') {
        setSignInError('A sign-in popup is already open. Please close any extra popups or finish the current sign-in.');
      } else {
        setSignInError('Sign-in failed. Please try again.');
      }
    } finally {
      setSigningIn(false);
    }
  };

  useEffect(() => {
    document.title = `${Config.TAB_PREFIX}Admin`;
  }, []);

  // ...existing code...

  return (
    <>
      <PageHeader header="Admin" />
      <Container maxWidth="md">
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            marginTop: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography component="h2" variant="h5" gutterBottom>
            Admin Login Required
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Please sign in with your admin account to access admin features.
          </Typography>
          {/* Unauthorized message if signed in but not admin */}
          {isSignedIn && !isAdmin && (
            <Typography color="error" sx={{ mb: 2 }}>
              You do not have access.
            </Typography>
          )}
          {signInError && (
            <Typography color="error" sx={{ mb: 2 }}>
              {signInError}
            </Typography>
          )}
          <Button
            variant="contained"
            size="large"
            onClick={handleSignIn}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
            disabled={signingIn}
          >
            <LoginIcon type={LoginIconType.Google} />
            {signingIn ? 'Signing in...' : 'Sign in with Google'}
          </Button>
        </Paper>
      </Container>
    </>
  );
}

export default AdminPage;
